import React, {Component} from 'react';

class NotFoundPage extends Component{
        constructor(props){
                super(props)
                this.state={
                }
        }

        render(){
                return <div style={{backgroundColor:"red",width:"300px",height:"200px"}}>
                404
        </div>
        }
}

export default NotFoundPage;